import session_pskey from './session/pskey'
import cookies from './cookies'

/**
 * 检查登录态
 */
export default function ({ appid = '11000101', daid = '307', s_url }) {
  if (typeof __mds_pskey_cookie_valide !== 'undefined' && __mds_pskey_cookie_valide === 0 && cookies.get('p_uin').substr(1) * 1 && cookies.get('p_skey')) {
    return new session_pskey({
      uin: cookies.get('p_uin').substr(1) * 1,
      pskey: cookies.get('p_skey'),
      sessiontype: `pskey_${daid}`
    });
  } else {
    s_url = s_url || location.href;
    location.href = `https://ui.ptlogin2.qq.com/cgi-bin/login?style=9&appid=${appid}&daid=${daid}&s_url=${encodeURIComponent(s_url)}`
    return null;
  }
}
